export default function() {
    (function($) {
        const $searchWrap = $(".search-wrap");
        
        function closeSearch() {
            $(".search-wrap").addClass("animated fadeOut");
        }

        $(function() {
            $searchWrap.on(
                "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                function() {
                    if ($(this).hasClass("fadeIn")) {
                        $(this).removeClass("fadeIn");
                    }

                    if ($(this).hasClass("fadeOut")) {
                        $(this).removeClass("fadeOut animated");
                    }
                }
            );

            $(".search-wrap__close").on("click touch", function() {
                closeSearch();
            });

            $(".search-trigger").on("click touch", function() {
                if ($searchWrap.hasClass("animated")) {
                    closeSearch();
                } else {
                    $searchWrap.addClass("animated fadeIn");
                    $(".search-wrap .search-field").focus();
                }
            });
        });
    })(jQuery);
}


// WEBPACK FOOTER //
// ./src/js/partials/search.js